export default class MessageNames {
  static OwnedOrganizationsLoadedMessage = "OwnedOrganizationsLoadedMessage";
}